module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-client-action-buttons"
  }, [_c('div', {
    staticClass: "dropdown-buttons"
  }, [_c('EditInterventionRequestReveal', {
    attrs: {
      "request": _vm.item
    }
  }), _c('DetailInterventionRequestReveal', {
    attrs: {
      "request": _vm.item
    }
  }), _c('CompleteInterventionRequestReveal', {
    attrs: {
      "request": _vm.item
    }
  }), _c('ActionButton', {
    attrs: {
      "action": _vm.remove,
      "confirm": true,
      "color-class": "warning"
    }
  }, [_vm._v("Delete")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2cef6505!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/InterventionRequestButtons.vue
// module id = 2375
// module chunks = 1